import { render, staticRenderFns } from "./SettingCustomersCustomerRegistrationDisabled.vue?vue&type=template&id=6c20db2c&"
import script from "./SettingCustomersCustomerRegistrationDisabled.vue?vue&type=script&lang=ts&"
export * from "./SettingCustomersCustomerRegistrationDisabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports